"use strict";

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var TextMeasurer =
/*#__PURE__*/
function () {
  function TextMeasurer() {
    _classCallCheck(this, TextMeasurer);

    if (typeof document != "undefined") {
      this.canvas = document.createElement("canvas");
      this.context = this.canvas.getContext("2d");
      this.fontFamily = "Arial";
      this.fontSize = 13;
    }
  }

  _createClass(TextMeasurer, [{
    key: "setFontFamily",
    value: function setFontFamily(family) {
      this.fontFamily = family;
    }
  }, {
    key: "setFontSize",
    value: function setFontSize(size) {
      this.fontSize = size;
    }
  }, {
    key: "measure",
    value: function measure(text) {
      this.context.font = "".concat(this.fontSize, "px \"").concat(this.fontFamily, "\"");
      return {
        width: this.context.measureText(text).width,
        fontSize: this.fontSize,
        ideographicBaseline: this.fontSize * TextMeasurer.parameters.ideographicBaseline[0] + TextMeasurer.parameters.ideographicBaseline[1],
        hangingBaseline: this.fontSize * TextMeasurer.parameters.hangingBaseline[0] + TextMeasurer.parameters.hangingBaseline[1],
        alphabeticBaseline: this.fontSize * TextMeasurer.parameters.alphabeticBaseline[0] + TextMeasurer.parameters.alphabeticBaseline[1],
        middle: this.fontSize * TextMeasurer.parameters.middle[0] + TextMeasurer.parameters.middle[1]
      };
    }
  }], [{
    key: "GetGlobalInstance",
    value: function GetGlobalInstance() {
      if (this.globalInstance == null) {
        this.globalInstance = new TextMeasurer();
      }

      return this.globalInstance;
    }
  }, {
    key: "Measure",
    value: function Measure(text, family, size) {
      var inst = this.GetGlobalInstance();
      inst.setFontFamily(family);
      inst.setFontSize(size);
      return inst.measure(text);
    }
  }, {
    key: "ComputeTextPosition",
    value: function ComputeTextPosition(x, y, metrics) {
      var alignX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "left";
      var alignY = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "middle";
      var xMargin = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      var yMargin = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var cwidth = metrics.width;
      var cheight = (metrics.middle - metrics.ideographicBaseline) * 2;
      var cx = cwidth / 2,
          cy = cheight / 2;

      if (alignX == "left") {
        cx = -xMargin;
      }

      if (alignX == "right") {
        cx = cwidth + xMargin;
      }

      if (alignY == "top") {
        cy = -yMargin;
      }

      if (alignY == "bottom") {
        cy = cheight + yMargin;
      }

      return [x - cx, y - cheight + cy - metrics.ideographicBaseline];
    }
  }]);

  return TextMeasurer;
}();

TextMeasurer.parameters = {
  hangingBaseline: [0.7245381636743151, -0.005125313493913097],
  ideographicBaseline: [-0.2120442632498544, 0.008153756552125913],
  alphabeticBaseline: [0, 0],
  middle: [0.34642399534071056, -0.22714036109493208]
};
TextMeasurer.globalInstance = null;
exports.TextMeasurer = TextMeasurer;